module.exports = __webpack_public_path__ + "static/media/TemplateNote-Home.49481286.png";